import { useParams } from "react-router";
import PricingPage from "./PricingPage";
import { createNew } from "./transportPricingUtils";
import useCompanies, { getCompanyReference } from "../../../system/useCompanies";

const TransportPricingPageNew = () => {
	const [companies] = useCompanies();
	const { company } = useParams<{ company: string }>();
	const selectedCompany = companies?.find(f => f.name === company);

	if (!selectedCompany) {
		return null;
	}

	const pricing = createNew(getCompanyReference(selectedCompany));

	return (
		<PricingPage
			pricing={pricing}
			startEdit
		/>
	)
};

export default TransportPricingPageNew;
